import flatpickr from 'flatpickr';
(function () {
  const datePickerEl = document.querySelector('#date-picker');
  const options: any = {};

  if (datePickerEl) {
    const pickerEnabled = datePickerEl.getAttribute('data-enabled');
    const activeInput = document.querySelector<HTMLInputElement>('[name="addressBook"]:checked')?.id;

    const enabledId = pickerEnabled || `${activeInput}-delivery-data`;

    if (enabledId) {
      const availableDates = document.getElementById(enabledId);

      if (availableDates) {
        try {
          const { availableDeliveryDays } = JSON.parse(availableDates.innerHTML);
          if (availableDeliveryDays?.length >= 1) {
            options.enable = availableDeliveryDays;
            options.minDate = availableDeliveryDays[0];
          }
        } catch (e) {
          console.error(e);
        }
      }
    }

    flatpickr(datePickerEl, options);
  }
})();
